import { useEffect } from "react";
import { Container, Row } from "reactstrap";
import { Apps, Tasks } from "../../../constants";
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import { fetchTaskApiData, setActiveTab } from "../../../reduxToolkit/reducers/taskSlice";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import NavClass from "./navClass";
import TabClass from "./tabClass";

const TaskContainer = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchTaskApiData());
  }, [dispatch]);
  const activeToggle = (tab: string) => dispatch(setActiveTab(tab));

  return (
    <>
      <Breadcrumbs mainTitle={Tasks} parent={Apps} />
      <Container fluid>
        <div className="message-wrap bookmark-wrap">
          <Row>
            <NavClass activeToggle={activeToggle} />
            <TabClass />
          </Row>
        </div>
      </Container>
    </>
  );
};

export default TaskContainer;
